/* eslint react/jsx-key: off */
import React from 'react';
import {
    Create,
    FormTab,
    SaveButton,
    TabbedForm,
    TextInput,
    Toolbar,
    required,
} from 'react-admin';

const AccountEditToolbar = ({ permissions, ...props }) => (
    <Toolbar {...props}>
        <SaveButton
            label='resources.actions.save_and_show'
            redirect="show"
            submitOnEnter={true}
        />
        {permissions === 'admin' && (
            <SaveButton
                label='resources.actions.save_and_next'
                redirect={false}
                submitOnEnter={false}
                variant="flat"
            />
        )}
    </Toolbar>
);


const AccountCreate = function({ permissions, ...props }) {

    return (
    <Create {...props}>
        <TabbedForm toolbar={<AccountEditToolbar permissions={permissions} />}>
            <FormTab label="resources.accounts.form.summary" path="">
                
                <TextInput
                    source="code"
                    defaultValue=""
                    validate={required()}
                />
                
                <TextInput
                    source="name"
                    defaultValue=""
                    validate={required()}
                />
                
            </FormTab>
        </TabbedForm>
    </Create>
    )
};

export default AccountCreate;
